/**
 * Shared chart constants/helpers (no ChartNode import — avoids HMR circular deps).
 */

export const CHART_TYPES = ['bar', 'line', 'area', 'pie'];

export const CHART_DEFAULT_PALETTE = [
  '#3c84f4',
  '#f44e3b',
  '#3ec979',
  '#f5b400',
  '#9b59b6',
  '#1abc9c',
  '#e67e22',
  '#34495e',
];

export function createDefaultChartData(chartType = 'bar') {
  if (chartType === 'pie') {
    return {
      chartType: 'pie',
      title: 'Untitled Chart',
      showLegend: true,
      width: 480,
      height: 320,
      categories: ['A', 'B', 'C', 'D'],
      series: [
        {
          name: 'Series 1',
          color: CHART_DEFAULT_PALETTE[0],
          colors: CHART_DEFAULT_PALETTE.slice(0, 4),
          data: [30, 20, 25, 25],
        },
      ],
    };
  }

  return {
    chartType,
    title: 'Untitled Chart',
    showLegend: true,
    width: 480,
    height: 320,
    categories: ['Q1', 'Q2', 'Q3', 'Q4'],
    series: [
      {
        name: 'Series 1',
        color: CHART_DEFAULT_PALETTE[0],
        data: [12, 19, 14, 22],
      },
      {
        name: 'Series 2',
        color: CHART_DEFAULT_PALETTE[1],
        data: [9, 7, 16, 11],
      },
    ],
  };
}

export function $isChartNode(node) {
  return node != null && node.getType() === 'chart';
}
